module.exports = __webpack_public_path__ + "static/media/desc-dosecurves.f03394fe.webp";